export const getImageUrl = (url: string) => {
  return process.env.NEXT_PUBLIC_STRAPI_API_URL+url;
};

export const getFormattedDate = (date: string) => {
  return new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
};
